/*@flow*/

export function attach(obj: Object = {}, element: any, ow: any) {
  if (!element) {
    console.warn('[events.attach] Element is undefined.');
    return;
  }
  element.__events__ = {};
  Object.keys(obj).forEach(k => {
    let callback = obj[k];
    const cb = e => {
      try {
        callback({ e, element, map: ow });
      } catch (e2) {
        console.error(`[Unraised]: ${e2}`);
      }
    };
    element.__events__[k] = cb;
    element.on(k, cb);
  });
}

export function detach(obj: Object = {}, element: any) {
  if (!element) {
    console.warn('[events.detach] Element is undefined.');
    return;
  }
  const ev = element.__events__;
  Object.keys(obj).forEach(k => {
    element.off(k, ev && ev[k]);
  });
}
